module.exports = __webpack_public_path__ + "static/img/knee_banner.48dcdf5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/knee_banner.svg
// module id = 4k4+
// module chunks = 0